/**
 * Small SVG icons shared across the shell. Everything here strokes with
 * `currentColor` so the parent's `color:` drives the visual — callers
 * put these inside buttons/chips that already colour themselves.
 *
 * `aria-hidden` is on the SVG because every current caller wraps this
 * in a `<button aria-label="…">`. Add a `role="img"` + `<title>` on
 * a per-icon basis if a caller ever renders one standalone.
 */

interface IconProps {
  size?: number;
}

/** Check mark — used on accept/apply/confirm affordances. */
export function CheckIcon({ size = 14 }: IconProps = {}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3.5 8.5 6.5 11.5 12.5 4.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Close / dismiss / reject "x". */
export function XIcon({ size = 14 }: IconProps = {}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M4 4 L12 12 M12 4 L4 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
